import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { forgotPasswordFetch } from "./function";
import { REQUEST_STATUS } from "../../../constant/common-constants";

export interface IForgotPasswordSlice {
  email: string;
  status: any;
  errors: any;
}

export const initialState: IForgotPasswordSlice = {
  email: "",
  status: REQUEST_STATUS.IDLE,
  errors: null,
};

const forgotPasswordSlice = createSlice({
  name: "forgotPassword",
  initialState,
  reducers: {
    setForgotPassword(state, action) {
      state = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(
      forgotPasswordFetch.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.status = REQUEST_STATUS.SUCCEEDED;
        state.email = action.payload;
      }
    );
    builder.addCase(  forgotPasswordFetch.rejected,
 (state, action: PayloadAction<any>) => {
        state.status = REQUEST_STATUS.FAILED;
        state.errors = action.payload;
      }
    );
    builder.addCase(forgotPasswordFetch.pending, (state) => {
      state.status = REQUEST_STATUS.PENDING;
    });
  },
});

export const { setForgotPassword } = forgotPasswordSlice.actions;
export const forgotPasswordReducer = forgotPasswordSlice.reducer;
